import { validateArguments } from '../../SignatureValidation';
export var ConcatFn;
(function (ConcatFn) {
    ConcatFn.Name = `CONCAT`;
    ConcatFn.Stage = "SCALAR";
    ConcatFn.Signature = `CONCAT(<string>, ...<string>)`;
    function make(callName, args, type, role) {
        return {
            name: ConcatFn.Name,
            stage: ConcatFn.Stage,
            data: { role, type },
            value(...values) {
                let result = '';
                if (values.length < 2) {
                    throw new Error(`CONCAT function expects 2 or more arguments ` +
                        `but received ${values.length}`);
                }
                for (const value of values) {
                    if (value == null) {
                        return null;
                    }
                    if (typeof value === 'string') {
                        result += value;
                    }
                    else {
                        throw new Error(`CONCAT function expects input to be of type (string) ` +
                            `but received (${typeof value})`);
                    }
                }
                return result;
            },
        };
    }
    ConcatFn.make = make;
    function validate(callNode, callName, args) {
        const arity = args.length;
        const sig = {
            arguments: arity >= 2
                ?
                    Array(arity).fill("STRING")
                :
                    ["STRING", "STRING"],
            meta: {
                name: ConcatFn.Name,
                signature: ConcatFn.Signature,
                location: callNode.location,
                variadic: true,
            },
        };
        return validateArguments(sig, args);
    }
    ConcatFn.validate = validate;
})(ConcatFn || (ConcatFn = {}));
